import MD5 from 'crypto-js/md5';

/**
 * Encrypts a password using MD5 hash algorithm
 * @param {string} password - The plain text password to encrypt
 * @returns {string} - The MD5 hash of the password in hexadecimal format
 */
export const encryptMD5 = (password) => {
  return MD5(password.trim()).toString();
};
